import { useEffect, useState } from "react";
import useSWR from "swr";
import { AgentService } from "@/services/agent/agent.service";
import { defaultSWROption } from "@/services/api/api.service";
import { useInfiniteThreads } from "./useInfiniteThreads";

export const useModels = (threadId?: string) => {
  const { threads } = useInfiniteThreads();
  const currentThread = threads.find((t) => t.id === threadId);

  const { data, error, isLoading } = useSWR(
    "agent/models",
    () => AgentService.getAvailableModels(),
    defaultSWROption,
  );

  const threadFamily = currentThread?.metadata?.model_family;
  const allModels = data ?? [];
  const models = threadFamily
    ? allModels.filter((m) => m.modelFamily === threadFamily)
    : allModels;
  const defaultModel = models.find((m) => m.isDefault);
  const threadModelKey = currentThread
    ? models.find(
      (m) =>
        m.modelName === currentThread.metadata.model_name
        && (m.reasoningEffort ?? "") === (currentThread.metadata.reasoning_effort ?? ""),
    )?.key
    : undefined;

  const [_selectedModelKey, setSelectedModelKey] = useState<string | undefined>();

  useEffect(() => {
    setSelectedModelKey(undefined);
  }, [threadId]);

  const selectedModelKey = _selectedModelKey ?? threadModelKey ?? defaultModel?.key;
  const selectedModel = models.find((m) => m.key === selectedModelKey);

  return {
    currentThread,
    models,
    defaultModel,
    selectedModelKey,
    setSelectedModelKey,
    selectedModelName: selectedModel?.modelName,
    selectedReasoningEffort: selectedModel?.reasoningEffort,
    isLoading,
    error,
  };
};
